var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.scrollDown}},[_c('span',{staticClass:"header__scroll-indicator__message"},[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }